/**
 * Client-side slugify — same rules as the server `slugify` in
 * apps/api/src/lib/slug.ts. Used for live slug preview while the user types
 * a title; server re-runs its own slugify on the final submitted value.
 *
 * Allows Thai (U+0E00-U+0E7F) + lowercase Latin + digits; collapses
 * everything else to single dashes; trims leading/trailing dashes.
 */
export function slugifyForPreview(input: string, maxLength = 80): string {
  return input
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '') // Latin combining diacritics; Thai marks preserved (U+0E00+)
    .toLowerCase()
    .replace(/[^฀-๿a-z0-9]+/gu, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, maxLength);
}
